import type React from 'react';

import { Avatar } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';

import asset from '#src/app/pages/petitionDetails/shared/assets/advocates/changeUser.webp';

import type { AdvocateAvatarProps } from '../../types';
import { HAS_ADVOCATES_STATE } from '../../util';

export const AdvocateAvatar: React.FC<AdvocateAvatarProps> = ({ hasAdvocatesState, petitionAdvocates }) => {
	const { translate } = useI18n();

	if (hasAdvocatesState === HAS_ADVOCATES_STATE.none) {
		return <Avatar alt={translate('corgi.petition.advocates.avatar_alt_starter')} size="large" src={asset} />;
	}

	// If there is one advocate, and the first advocate exists, render the avatar
	if (hasAdvocatesState === HAS_ADVOCATES_STATE.one && petitionAdvocates?.[0]) {
		const advocate = petitionAdvocates[0];
		return (
			<Avatar
				size="large"
				src={advocate.photo?.userSmall.url}
				initial={!advocate.photo?.userSmall.url ? advocate.firstName.charAt(0) : undefined}
				alt={translate('corgi.petition.advocates.avatar_alt', {
					firstName: advocate.firstName,
					lastInitial: advocate.lastInitial ?? undefined,
				})}
			/>
		);
	}

	// If there are multiple advocates, render the avatar
	if (hasAdvocatesState === HAS_ADVOCATES_STATE.multiple && petitionAdvocates) {
		return (
			<div className="flex items-center [&>*:not(:first-child)]:-ml-3">
				{petitionAdvocates.slice(0, 4).map((advocate) => {
					return (
						<Avatar
							key={advocate.id}
							size="medium"
							src={advocate.photo?.userSmall.url}
							initial={!advocate.photo?.userSmall.url ? advocate.firstName.charAt(0) : undefined}
							alt={translate('corgi.petition.advocates.avatar_alt', {
								firstName: advocate.firstName,
								lastInitial: advocate.lastInitial ?? undefined,
							})}
							className="border-stroke-inverse-strong shrink-0 border"
						/>
					);
				})}
			</div>
		);
	}

	return null;
};
